import { render } from "./user-privtae-training.vue?vue&type=template&id=614ff46e&scoped=true"
import script from "./user-privtae-training.vue?vue&type=script&lang=js"
export * from "./user-privtae-training.vue?vue&type=script&lang=js"

import "./user-privtae-training.vue?vue&type=style&index=0&id=614ff46e&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614ff46e"]])

export default __exports__